import React, { useState } from 'react';
import Modal from '@carvana/showroom-modal';
import {
  ModalContent,
  ModalMessage,
  CautionImage,
} from './EnrollmentFailure.styles';
import { currentAssetsUrl } from '../../../../../utils/baseUrlUtil';

const EnrollmentFailure = (props: { isOpen: any }) => {
  const { isOpen } = props;
  const [openFailureModal, setFailureModal] = useState(isOpen);

  const closeModal = () => {
    setFailureModal(!openFailureModal);
  };

  return (
    <Modal
      headerText="WARNING"
      closeModal={closeModal}
      isOpen={openFailureModal}
      testHook="test-modal"
      mode="light"
      portalDivId="shaun-test"
    >
      <ModalContent>
        <CautionImage
          src={`${currentAssetsUrl(
            process.env.NODE_ENV
          )}/op-assets/my-cars/Caution.png`}
        />
        YOUR PAYMENT MAY STILL BE PROCESSING.
        <ModalMessage>
          Please check payment history before making any additional payments.
        </ModalMessage>
      </ModalContent>
    </Modal>
  );
};

export default EnrollmentFailure;
